import React from 'react'
import Navbar from '../Navbar'
import Footer from '../Footer'

const CancellationAndRefund = () => {
  return (<><Navbar />
  <section className="breadcrumb-area breadcrumb__hide-img" style={{ backgroundImage: "url('https://ik.imagekit.io/ipuppyyt/Oasis%20Arena/Untitled_1920_x_565_px_4_L1zXlMYPq.png?updatedAt=1700487938980')" }}>
    <div className="container">
      <div className="breadcrumb__wrapper">
        <div className="row">
          <div className="col-12">
            <div className="breadcrumb__content">
              <h2 className="title">Cancellation and Refund Policy</h2>
              <p className=' font-bold'>Last updated : November 18 2023</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section className='ml-7 mr-7 mt-[50px] mb-20 md:ml-20 md:mr-20 md:mt-24 md:mb-24 lg:ml-32 lg:mr-32 lg:mt-24 lg:mb-24 text-white'>
    <p className='font-bold text-white list-disc'>Oasis Arena believes in helping its customers as far as possible and has therefore a liberal cancellation policy. Under this policy:</p>
    <ul className='text-white'>
      <li className='text-white'>● Cancellations will be considered only if the request is made immediately after placing the order. However, the cancellation request may not be entertained if the orders have been communicated to the vendors/merchants and they have initiated the process of shipping them.</li>
      <li className='text-white'>● Oasis Arena does not accept cancellation requests for perishable items like flowers, eatables etc. However, refund/replacement can be made if the customer establishes that the quality of product delivered is not good.</li>
      <li className='text-white'>● In case of receipt of damaged or defective items please report the same to our Customer Service team. The request will, however, be entertained once the merchant has checked and determined the same at his own end. This should be reported within 2 days of receipt of the products.</li>
      <li className='text-white'>● In case you feel that the product received is not as shown on the site or as per your expectations, you must bring it to the notice of our customer service within 2 days of receiving the product. The Customer Service Team after looking into your complaint will take an appropriate decision.</li>
      <li className='text-white'>● In case of complaints regarding products that come with a warranty from manufacturers, please refer the issue to them.</li>
      <li className='text-white'>● In case of any Refunds approved by the Oasis Arena, it’ll take 1-2 days for the refund to be processed to the end customer.</li>
    </ul>
  </section>
  <br /><br />
  <Footer />
</>)
}

export default CancellationAndRefund